"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function createContext() {
    var context = react_1.default.createContext(undefined);
    function useContext() {
        var c = react_1.default.useContext(context);
        if (!c)
            throw new Error('useCtx must be inside a Provider with a value');
        return c;
    }
    return [useContext, context.Provider, context.Consumer];
}
exports.default = createContext;
//# sourceMappingURL=createContext.js.map